module.exports = __webpack_public_path__ + "img/1513435332.d8baa3dd.jpg";